import React from "react";

const HeroSection = () =>{
    return(
        <>
        {/* HERO SECTION START */}
        <div className="hero1" style={{backgroundImage: "url(/assets/img/bg/hero1-bg.png)", backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover"}}>
          <div className="container d-flex">
            <div className="row">
                <div className="main-headding">
                  <span className="span" data-aos="zoom-in-left" data-aos-duration="700"><img src="/assets/img/icons/span1.png" alt=""/> Exchange Rate API</span>
                  <h1 className="title tg-element-title">Real-Time Forex Data 
                  <span className="after"> Access </span></h1>
                  <div className="space16"></div>
                  <p>Get instant access to live exchange rates, historical data, and seamless currency conversion capabilities.</p>

                  <div className="space30"></div>
                  <div className="buttons">
                    <a className="theme-btn1" href="/login">Sign Up <span><i className="fa-solid fa-arrow-right"></i></span></a>
                  </div>
                </div>
              </div>

              <div className="col-lg-7 hero1-image-col">
                <div className="hero1-all-images">
                  <div className="image1">
                    <img
                      src="/assets/img/hero/hero-api-response.jpg"
                      alt="Exchange Rate API response example"
                    />
                  </div>
                  <div className="shape1">
                    <img src="/assets/img/shapes/header1-shape1.png" alt=""/>
                  </div>
                  <div className="shape2">
                    <img src="/assets/img/shapes/header1-shape2.png" alt=""/>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className="">
          <div className="container">
            <div className="row hero-bottom-area">
              <div className="col-lg-3">
                <div className="single-box">
                  <div className="icon">
                  🌐 
                  </div>
                  <div className="headding">
                    <h5>Real-Time Forex Data</h5>
                    <p>Updated every second from live interbank feed</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="single-box">
                  <div className="icon">
                  🛡️
                  </div>
                  <div className="headding">
                    <h5>Human Support, Always On</h5>
                    <p>Speak to real experts — not just bots</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="single-box">
                  <div className="icon">
                  🧑‍💻
                  </div>
                  <div className="headding">
                    <h5>Developer-First API Design</h5>
                    <p>Fast, clean, and easy to integrate</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="single-box">
                  <div className="icon">
                  📞
                  </div>
                  <div className="headding">
                    <h5>Unmatched Reliability</h5>
                    <p>Guaranteed 99.99% API uptime</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        {/* HERO SECTION END */}
        </>
    )
}

export default HeroSection;
